import React from "react";
//#region types
import { SupplierProps } from "models/propTypes/userProfilePropTypes";
//#endregion
//#region components
import Organization from "./organization";
import Person from "./person";
//#endregion
import { UrlHelper } from "utils/helpers";

const Supplier: React.FC<SupplierProps> = (props) => {
  const { id, name, orgNr, onProfileClick } = props;

  const url = UrlHelper.formatPath(`/Supplier/${id}`);

  return orgNr ? (
    <Organization id={id} name={name} orgNr={orgNr} href={url} onProfileClick={onProfileClick} />
  ) : (
    <Person
      id={id}
      name={name}
      hideProfileImage
      href={url}
      onProfileClick={onProfileClick}
      className={props.className}
    />
  );
};

export default Supplier;
